// System
import { Select } from '@mui/material';
import { useMemo } from 'react';
import { MenuItemEx } from '@Components/shared/selects/MenuItemEx';
import { useGeneral } from '@Modal/hooks/general/useGeneral';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';

const RgsDropdown = () => {
  const { handleRgsChange, rgs } = useGeneral();
  const { currentUser } = useAuthorization();

  const rgsForAdmin = ['EU', 'EU2', 'SA', 'AS', 'AS1', 'AF', 'AF1', 'AF2', 'AF3'];
  const isSuper = currentUser?.isSuper;
  const userRgsIds = currentUser?.rgsIds || [];

  const dropdownConfig = useMemo(() => {
    const options = isSuper ? rgsForAdmin : userRgsIds;
    const shouldShowSelect = isSuper || userRgsIds.length > 1;
    const currentRgs = rgs;

    return {
      options,
      shouldShowSelect,
      currentRgs,
    };
  }, [rgs, isSuper, userRgsIds, rgsForAdmin]);

  if (!dropdownConfig.shouldShowSelect) return null;

  return (
    <Select
      sx={{
        position: 'absolute',
        width: '86px',
        height: '32px',
        left: '16px',
        top: '20px',
      }}
      value={dropdownConfig.currentRgs}
      onChange={(event) =>
        handleRgsChange(
          event.target.value as 'EU' | 'EU2' | 'AS' | 'AS1' | 'SA' | 'AF' | 'AF1' | 'AF2' | 'AF3'
        )
      }
    >
      {dropdownConfig.options.map((region) => (
        <MenuItemEx key={region} name={region} value={region}>
          {region}
        </MenuItemEx>
      ))}
    </Select>
  );
};

export default RgsDropdown;
